import React from "react";
import { Combo } from "../../common/components/comboBox"
import { formGroup } from "../../common/components/formGroup";
import Store from "../RefrigeranteStore";
import { RefrigeranteType } from "../../generated";

const Combobox = Combo<RefrigeranteType>();
interface Props {
    value: string | null,
    onChange: (type: RefrigeranteType | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
const __TipoRefrigeranteSelector = ({ onChange, value, error, label, onBlur, onFocus }: Props) => {

    const data = Store.useAll();
    return <Combobox
        label={label ?? "Refrigerante"}
        allowNull
        data={data ?? []}
        textField={x => x.description ?? ""}
        onSelect={onChange}
        value={data?.find(x => x.id == value) ?? null}
        error={error}
        onBlur={onBlur}
        onFocus={onFocus}
        busy={!data}
    />;
}
export default formGroup(__TipoRefrigeranteSelector);
